import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select, Paper } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import PrimaryButton from "./Button/PrimaryButton";
import TemporaryDrawer from "./Drawer/Drawer";
import ListFilterItem from "./ListFilterItem/ListFilterItem";

const filterStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    '& .filterItems': {
        flex: 1,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    '& .filterFooter': {
        padding: '16px 0',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundColor: '#fff'
    }
};

export const CompanyFilterDrawer = ({ setOn, setFilter }) => {
    const { t } = useTranslation();

    const handleFilter = () => {
        setOn(false);
        if (setFilter) {
            setFilter();
        }
    };

    return (
        <Box sx={filterStyle}>
            <h3>{t('filtruoti')}</h3>
            
            <Box className="filterItems">
                <ListFilterItem
                    size='small'
                    options={['active', 'not_confirmed']}
                    optionsText={[t('patvirtinta'), t('negalioja')]}
                    paramName={"Status"}
                    label={t('statusas_label')}
                />
                <ListFilterItem
                    size='small'
                    options={['unlimited', 'limited']}
                    optionsText={[t('neribotai'), t('ribotai')]}
                    paramName={"ValidityType"}
                    label={t('galiojimo_tipas')}
                />
                <ListFilterItem
                    size='small'
                    options={['this_year', 'next_year', 'any']}
                    optionsText={[t('siais_metais'), t('kitais_metais'), t('bet_kada')]}
                    paramName={"ExpirationTime"}
                    label={t('galiojimas_baigsis')}
                />
            </Box>

            <Box className="filterFooter">
                <PrimaryButton
                    onClick={handleFilter}
                    sx={{ width: '100%' }}
                >
                    {t('filtruoti')}
                </PrimaryButton>
            </Box>
        </Box>
    );
};

export const CompanyFilter = ({ setFilter }) => {
    const { t } = useTranslation();
    const [drawer, setDrawer] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');

    const handleStatusChange = (event) => {
        const value = event.target.value;
        setStatusFilter(value);
        
        // Apply filtering logic based on status
        if (value && setFilter) {
            setFilter(value);
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 2, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
                <InputLabel id="status-filter-label">{t('statusas_label')}</InputLabel>
                <Select
                    labelId="status-filter-label"
                    value={statusFilter}
                    onChange={handleStatusChange}
                    label={t('statusas_label')}
                >
                    <MenuItem value="">
                        <em>{t('visi')}</em>
                    </MenuItem>
                    <MenuItem value="active">{t('patvirtinta')}</MenuItem>
                    <MenuItem value="not_confirmed">{t('negalioja')}</MenuItem>
                </Select>
            </FormControl>
            
            <TemporaryDrawer
                className={'drawer right'}
                classNameBtn={'copyBtn filtrasBtn'}
                side={'right'}
                text={t('filtruoti')}
                endIcon={<FilterListIcon />}
                on={drawer}
                setOn={setDrawer}
                elements={
                    <div className="filterDrawer filterPadding">
                        <CompanyFilterDrawer setOn={setDrawer} setFilter={setFilter} />
                    </div>
                }
            />
        </Paper>
    );
};

export default CompanyFilter;